var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-wrapper"},[_c('div',{staticClass:"progress",style:({ width: _vm.percent + '%' })},[_c('div',{staticClass:"progress-bg"})])])}
var staticRenderFns = []

export { render, staticRenderFns }